import { useQuery } from '@tanstack/react-query';
import { FeatureFlagsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useFeatureFlagsQueryControllerGetFeatureFlagByIdQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['featureFlagsQueryControllerGetFeatureFlagById', accessControlScope, args],
        queryFn: async () => {
            const api = new FeatureFlagsApi(accessControlConfig);
            return api.featureFlagsQueryControllerGetFeatureFlagById(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useFeatureFlagsQueryControllerGetFeatureFlagByIdQuery.js.map